import React, { useEffect, useRef } from 'react';

const Snowflakes = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const types = ['circle', 'dot', 'paw'];
    const flakes = [];

    const createFlake = () => {
      const flake = document.createElement('div');
      flake.className = `snowflake ${types[Math.floor(Math.random() * types.length)]}`;

      const size = Math.random() * 12 + 4;
      const startX = Math.random() * 100;
      const duration = Math.random() * 12 + 8;
      const drift = (Math.random() - 0.5) * 200;
      const spin = Math.random() * 720 - 360;

      flake.style.cssText = `
        left: ${startX}%;
        width: ${size}px;
        height: ${size}px;
        animation-duration: ${duration}s;
        animation-delay: ${Math.random() * 5}s;
        --drift: ${drift}px;
        --spin: ${spin}deg;
      `;

      if (flake.classList.contains('paw')) {
        flake.innerHTML = '🐾';
        flake.style.width = 'auto';
        flake.style.height = 'auto';
        flake.style.fontSize = `${Math.random() * 10 + 8}px`;
      }

      container.appendChild(flake);
      flakes.push(flake);

      setTimeout(() => {
        if (flake.parentNode) {
          flake.parentNode.removeChild(flake);
        }
        const idx = flakes.indexOf(flake);
        if (idx > -1) flakes.splice(idx, 1);
      }, (duration + 5) * 1000);
    };

    // Initial batch
    for (let i = 0; i < 15; i++) {
      setTimeout(createFlake, Math.random() * 3000);
    }

    // Continuous creation
    const interval = setInterval(createFlake, 1200);

    return () => {
      clearInterval(interval);
      flakes.forEach(f => {
        if (f.parentNode) f.parentNode.removeChild(f);
      });
    };
  }, []);

  return <div ref={containerRef} className="snowflakes" />;
};

export default Snowflakes;
